import React from 'react'

const ViewBuyer = () => {
  return (
    <div>ViewBuyer</div>
  )
}

export default ViewBuyer